import { Box } from '@mui/material';

import FAQItem from './FAQItem';
import { faqs } from '../../constants/faq';
import { formatDate } from '../../helpers/format-date';

const FAQSection = ({ surveyEndDate }) => {
  return (
    <Box>
      {faqs(formatDate(surveyEndDate)).map((e, i) => (
        <FAQItem
          key={`faq-item-${i}`}
          question={e.question}
          answer={e.answer}
        />
      ))}
    </Box>
  );
};

export default FAQSection;
